module.exports = new __parcel__URL__("atlassian-intelligence-light.ffe3e221.svg").toString();